import { AsyncQueuer } from '@tanstack/react-pacer';

export const INDEX_QUEUE_CONCURRENCY = 5;

const indexQueuer = new AsyncQueuer<() => Promise<unknown>>(task => task(), {
  concurrency: INDEX_QUEUE_CONCURRENCY,
  started: true,
  throwOnError: true
});

export function enqueueIndexCall<T>(task: () => Promise<T>): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    indexQueuer.addItem(() => task().then(resolve, reject));
  });
}

export function useIndexQueuer() {
  return indexQueuer;
}
